import { isoZ, z } from 'my-zod'

export const SelectSubscriptionStatusEnum = z.enum([
  'trialing',
  'active',
  'incomplete',
  'incomplete_expired',
  'past_due',
  'canceled',
  'unpaid',
  'paused'
])

export type SelectSubscriptionStatus = z.infer<typeof SelectSubscriptionStatusEnum>

export const cancellationReasonCodes = {
  ['No Outfitters Near Me']: ['Within a 30-60 min drive', 'Within a 60-90 min drive', 'Beyond 90 min drive'],
  ['Lack of Understanding']: [
    'Too Expensive',
    'How credits worked',
    'How to book a ride',
    'How to find an Outfitter near me',
    'Other'
  ],
  ['Non Usage']: ['Vehicle Availability', 'Not enough time to ride', 'Loss of interest'],
  ['Other Reasons']: [
    'Purchased Polaris vehicle',
    'Purchased other product',
    'Relocation',
    'Change in family status',
    'Health/Medical',
    'Other'
  ]
}

export const cancellationReasonCodeOptions = Object.entries(cancellationReasonCodes)
  .map(([reason, subreasons]) =>
    subreasons.map((subreason) => ({
      label: subreason,
      value: `${reason}:${subreason}`
    }))
  )
  .flat()

const cancellationReasonCodesEnum = z.enum(cancellationReasonCodeOptions.map((op) => op.value) as [string, ...string[]])

export const customerSubscriptionModel = z.object({
  id: z.string(),
  customerId: z.string(),
  subscriptionPlanId: z.number(),
  subscriptionPlanPriceId: z.number().nullable(),
  status: SelectSubscriptionStatusEnum,
  cancellationReasonCode: cancellationReasonCodesEnum.nullable(),
  cancellationReasonDescription: z.string().nullable(),
  activationDate: isoZ.instant().nullable(),
  cancellationDate: isoZ.instant().nullable().setLabel('Subscription Cancellation Date'),
  createdDate: isoZ.instant().nullable(),
  lastModifiedDate: isoZ.instant().nullable()
})

export type customerSubscriptionModel = z.infer<typeof customerSubscriptionModel>
